<ion-header class="header --transparent --w-back-button">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item
          *ngFor="let breadcrumb of breadcrumbs"
          class="breadcrumb__item"
          [routerLink]="[breadcrumb.link]"
          routerDirection="back"
          detail="false"
        >
          <span [innerHTML]="breadcrumb.name"></span> <span class="breadcrumb__item__dash">/</span>
        </ion-item>
      </ion-list>
      <ion-back-button [defaultHref]="defaultHref" text="" icon="arrow-back-outline"></ion-back-button>
    </ion-buttons>
    <ion-title>
      <span [innerHTML]="(chapter$ | async)?.name"></span>
    </ion-title>
    <ion-buttons slot="end">
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="chapter">
  <div class="chapter__summary">
    <div class="chapter__summary__left">
      <video *ngIf="(chapter$ | async)?.videoUrl; let source" controls><source [src]="source" /></video>

      <ion-img
        *ngIf="!(chapter$ | async)?.videoUrl"
        [src]="(learningModule$ | async) | learningModulesDefaultImage:(chapter$ | async)"
      ></ion-img>
    </div>
    <div *ngIf="(chapter$ | async)?.description" class="chapter__summary__right" [innerHTML]="(chapter$ | async)?.description"></div>
  </div>

  <app-challenge-layout>
    <div
      class="challenge__header --reverse"
      [appBackgroundImage]="(learningModule$ | async) | learningModulesDefaultImage:(chapter$ | async)"
    >
      <span class="challenge__header__title" [innerHTML]="(chapter$ | async)?.name"></span>
    </div>
    <div class="challenge__content">
      <div class="challenge__content__text --summary --left">
        <input type="checkbox" id="expanded" />
        <span [innerHTML]="(chapter$ | async)?.description"></span>
        <label for="expanded" role="button" [innerHTML]="'BUTTONS.SHOW_MORE' | translate"></label>
      </div>
    </div>
  </app-challenge-layout>

  <ion-list class="chapter__list">
    <ion-item
      *ngFor="let challenge of challenges$ | async"
      class="chapter__list__item"
      detail="false"
      [routerLink]="[routes.challenges, challenge.id]"
    >
      <div class="chapter__list__item__content">
        <ion-img
          class="chapter__list__item__content__image"
          [src]="(learningModule$ | async) | learningModulesDefaultImage:(chapter$ | async):challenge"
          [alt]="challenge.name"
        ></ion-img>
        <div class="chapter__list__item__content__description">
          <div class="chapter__list__item__content__description__title">
            <ion-icon class="chapter__list__item__content__description__title__lock" name="lock-closed" *ngIf="false"></ion-icon>
            <span [innerHTML]="challenge.name"></span>
          </div>
          <span
            class="chapter__list__item__content__description__steps"
            [innerHTML]="'LEARNING_MODULES.CHAPTER_STEPS' | translate:{ count: (challenge.id | stepsCount | async) || 0 }"
          ></span>
        </div>
      </div>
      <ion-checkbox *ngIf="false" disabled checked slot="end"></ion-checkbox>
    </ion-item>
  </ion-list>
</ion-content>
